import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var createArrayBouncer = function createArrayBouncer(arr) {
  return function (item) {
    var allowPush = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (allowPush) {
      arr.push(item);
    }
  };
};
export var getCookie = function getCookie(name) {
  if (typeof window === 'undefined') return undefined;
  var matches = document.cookie.match(new RegExp("(?:^|; )".concat(name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1'), "=([^;]*)")));
  return matches ? decodeURIComponent(matches[1]) : undefined;
};
export var setCookie = function setCookie(_ref) {
  var domain = _ref.domain,
    maxAge = _ref.maxAge,
    name = _ref.name,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '/' : _ref$path,
    _ref$secure = _ref.secure,
    secure = _ref$secure === void 0 ? true : _ref$secure,
    ttl = _ref.ttl,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  if (typeof window !== 'undefined') {
    var _ttl = Number(ttl);
    var _maxAge = Number(maxAge);
    var freshlyBakedCookie = ["".concat(name, "=").concat(value)];
    var cookiePropsBouncer = createArrayBouncer(freshlyBakedCookie);
    cookiePropsBouncer("domain=".concat(domain), Boolean(domain));
    cookiePropsBouncer("path=".concat(path), Boolean(path));
    cookiePropsBouncer("expires=".concat(new Date(new Date().getTime() + _ttl).toUTCString()), !Number.isNaN(_ttl));
    cookiePropsBouncer("max-age=".concat(_maxAge), !Number.isNaN(_maxAge));
    cookiePropsBouncer('secure', secure);
    document.cookie = freshlyBakedCookie.join(';');
  }
};
export var deleteCookie = function deleteCookie(name, props) {
  setCookie(_objectSpread(_objectSpread({}, props), {}, {
    name: name,
    value: '',
    maxAge: -1
  }));
};